import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  OnDestroy,
  Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VesselAvailabilityPreferencesDAO } from '../../../../../../../../../core/services/dao/vesselAvailabilityPreferencesDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { combineLatest, Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../../../../../../core/pure-functions/rx-helper';
import { ContainsSubscriptions } from '../../../../../../../../../core/services/interfaces/contains-subscriptions';
import { VesselAvailabilityDAO } from '../../../../../../../../../core/services/dao/VesselAvailabilityDAO';
import { concat } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { VesselAvailabilityPreferences } from 'anchor-shared/lib/model/entity/vesselAvailabilityPreferences';

@Component({
  selector: 'app-reservation-settings',
  templateUrl: './reservation-settings.component.html',
  styleUrls: ['./reservation-settings.component.scss'],
})
export class ReservationSettingsComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @Input()
  vessel: Vessel;

  @Input()
  settingsType: string;

  @Output() resetEditState = new EventEmitter<any>();
  isMobile: boolean;
  vesselPreferences: VesselAvailabilityPreferences;
  vesselId: number;
  subs: Subscription[] = [];
  savingSpinner = false;
  allowsMultiple: boolean;

  allows567Hours: boolean;
  allows910Hours: boolean;
  allows3hours: boolean;

  advanceNoticeMaxMonths: number;
  advanceNoticeMinHours: number;

  applyAdvancedAvailability: boolean;
  lastMinuteAvailability: number;
  gapLength: number;

  constructor(
    public dialogRef: MatDialogRef<ReservationSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private vesselAvailabilityPreferencesDAO: VesselAvailabilityPreferencesDAO,
    private vesselAvailabilityDAO: VesselAvailabilityDAO,
  ) {}

  ngOnInit() {
    this.isMobile = window && window.screen && window.screen.width < 960;
    if (this.vessel) {
      this.vesselPreferences = this.vessel.vesselAvailabilityPreferences;
      this.vesselId = this.vessel.id;
    } else if (this.isMobile) {
      this.vesselPreferences = this.data.vessel.vesselAvailabilityPreferences;
      this.vesselId = this.data.vessel.id;
      this.settingsType = this.data.settingsType;
    }
    this.allowsMultiple = this.vesselPreferences.allowsMultiple;

    this.allows567Hours = this.vesselPreferences.allows567Hours;
    this.allows910Hours = this.vesselPreferences.allows910Hours;
    this.allows3hours = this.vesselPreferences.allows3hours;
    this.advanceNoticeMaxMonths = this.vesselPreferences.advanceNoticeMaxMonths;
    this.advanceNoticeMinHours = this.vesselPreferences.advanceNoticeMinHours;
    this.applyAdvancedAvailability =
      this.vesselPreferences.applyAdvancedAvailability;
    this.lastMinuteAvailability = this.vesselPreferences.lastMinuteAvailability;
    this.gapLength = this.vesselPreferences.gapLength;
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  updateReservationSettings() {
    this.savingSpinner = true;
    const updateVesselPrefsSub = this.vesselAvailabilityPreferencesDAO.update(
      this.vesselId,
      this.vesselPreferences.id,
      {
        allowsMultiple: this.allowsMultiple,
        allows567Hours: this.allows567Hours,
        allows910Hours: this.allows910Hours,
        allows3hours: this.allows3hours,
        advanceNoticeMaxMonths: this.advanceNoticeMaxMonths,
        advanceNoticeMinHours: this.advanceNoticeMinHours,
        applyAdvancedAvailability: this.applyAdvancedAvailability,
        lastMinuteAvailability: this.lastMinuteAvailability,
        gapLength: this.gapLength,
      },
    );

    const updateAvailRecordsSub =
      this.vesselAvailabilityDAO.updateFullAvailabilitiesForVessel(
        this.vesselId,
      );
    const updateSub = updateVesselPrefsSub
      .pipe(mergeMap(() => updateAvailRecordsSub))
      .subscribe(() => {
        this.vesselPreferences.allowsMultiple = this.allowsMultiple;
        this.vesselPreferences.allows567Hours = this.allows567Hours;
        this.vesselPreferences.allows910Hours = this.allows910Hours;
        this.vesselPreferences.allows3hours = this.allows3hours;
        this.vesselPreferences.advanceNoticeMaxMonths =
          this.advanceNoticeMaxMonths;
        this.vesselPreferences.advanceNoticeMinHours =
          this.advanceNoticeMinHours;
        this.vesselPreferences.applyAdvancedAvailability =
          this.applyAdvancedAvailability;
        this.vesselPreferences.lastMinuteAvailability =
          this.lastMinuteAvailability;
        this.vesselPreferences.gapLength = this.gapLength;
        this.savingSpinner = false;
        if (this.isMobile) {
          this.dialogRef.close();
        } else {
          this.resetEditState.emit();
        }
      });
    this.subs.push(updateSub);
  }

  cancel() {
    if (this.isMobile) {
      this.dialogRef.close();
    } else {
      this.resetEditState.emit();
    }
  }
}
